import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {EventRegistrationRoutingModule} from './event-registration-routing.module';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {EventRegistrationComponent} from './event-registration.component';
import {EventRegistrationRepository} from './repositories/event-registration.repository';
import {EventRegistrationService} from './services/event-registration.service';

@NgModule({
  imports: [
    CommonModule,
    EventRegistrationRoutingModule,
    SearchBarModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    FormsModule,
    ModalConfirmationModule,
  ],
  declarations: [
    EventRegistrationComponent,
  ],
  providers: [
    EventRegistrationService,
    EventRegistrationRepository,
  ],
})

export class EventRegistrationModule {}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/event-registration/event-registration.module.ts